import React from 'react';

export const TableRow =(props)=> {
  // Expected ["Value 1",...,"Value N"]
  const mappingContents = props.contents.map((value) => <td scope="row"> {value} </td>);
  return (
      <tr>
        {mappingContents}
      </tr>
  );
}
